module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('scroll', {
    staticClass: "report-bottom report-detail",
    on: {
      "refresh": _vm.refresh
    }
  }, [_c('div', {
    staticClass: "report-detail-title icon-msg-h"
  }, [_c('span', {
    staticClass: "icon report-item-img"
  }), _vm._v(" "), _c('div', {
    staticClass: "f-largest"
  }, [_vm._v(_vm._s(_vm.queryParam.labItem))])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.qrcodeEnable),
      expression: "qrcodeEnable"
    }],
    staticClass: "report-detail-qrcode thick"
  }, [_c('p', [_vm._v("打印报告二维码")]), _vm._v(" "), _c('section', {
    staticClass: "thick",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('qrcode', {
    staticClass: "qrcode",
    attrs: {
      "size": 171,
      "cls": _vm.qrCls,
      "value": _vm.qrText
    }
  }), _vm._v(" "), _c('o2o-helper', {
    attrs: {
      "type": 0
    }
  })], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    staticClass: "thick-item"
  }, [_c('span', [_vm._v(_vm._s(_vm.labDetail.hospitalName))])]), _vm._v(" "), _c('li', {
    staticClass: "thick-item"
  }, [_c('span', {
    staticClass: "left-text"
  }, [_vm._v("卡号")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.labDetail.cardNo))])]), _vm._v(" "), _c('li', {
    staticClass: "thick-item"
  }, [_c('span', {
    staticClass: "left-text"
  }, [_vm._v("报告单号")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.queryParam.labId))])]), _vm._v(" "), _c('li', {
    staticClass: "thick-item"
  }, [_c('span', {
    staticClass: "left-text"
  }, [_vm._v("出单时间")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.queryParam.labTime))])])]), _vm._v(" "), _c('section', {
    staticClass: "report-wrapper"
  }, _vm._l((_vm.labItems), function(labItem, index) {
    return _c('section', {
      key: index,
      staticStyle: {
        "padding": "0 20px 5px",
        "background": "#fff",
        "margin-bottom": "5px"
      }
    }, [_c('div', {
      staticClass: "item-detail-title f-strong",
      on: {
        "click": function($event) {
          return _vm.showDetail(labItem)
        }
      }
    }, [_c('label', [_vm._v(_vm._s(labItem.labItem))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!labItem.showDetailInfo),
        expression: "!labItem.showDetailInfo"
      }],
      staticClass: "arr-gray-down"
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (labItem.showDetailInfo),
        expression: "labItem.showDetailInfo"
      }],
      staticClass: "arr-gray-up"
    })]), _vm._v(" "), (labItem.data.length > 0) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (labItem.showDetailInfo),
        expression: "labItem.showDetailInfo"
      }]
    }, _vm._l((labItem.data), function(item) {
      return _c('div', [_c('div', {
        staticClass: "report-table-title"
      }, [_c('div', {
        staticClass: "pull-left"
      }, [_c('label', [_vm._v(_vm._s(item.itemName))])])]), _vm._v(" "), _c('div', {
        staticClass: "report-table-container"
      }, [_c('table', {
        staticClass: "report-table"
      }, [_c('tr', {
        staticClass: "f-minor"
      }, [_c('td', [_vm._v("项目单位")]), _vm._v(" "), _c('td', [_vm._v("结果")]), _vm._v(" "), _c('td', [_vm._v("参考范围")])]), _vm._v(" "), _c('tr', [_c('td', {
        staticClass: "f-normal"
      }, [_vm._v(_vm._s(item.itemUnit))]), _vm._v(" "), _c('td', {
        staticClass: "f-normal"
      }, [_vm._v(_vm._s(item.itemResult) + "\n                                        "), (item.refRangeMax !== '') ? _c('div', {
        staticStyle: {
          "display": "inline"
        }
      }, [(~~(item.itemResult.split(' ')[0].replace(/[^0-9,.]/ig, '')) > ~~(item.refRangeMax)) ? _c('span', [_c('div', {
        staticClass: "up-frame"
      })]) : _vm._e(), _vm._v(" "), (~~(item.itemResult.split(' ')[0].replace(/[^0-9,.]/ig, '')) < ~~(item.refRangeMin)) ? _c('span', [_c('div', {
        staticClass: "down-frame"
      })]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "f-normal"
      }, [_vm._v(_vm._s(item.refRange))])])])])])
    }), 0) : _vm._e()])
  }), 0)]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "max-min f-identify",
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "up-frame"
  }), _vm._v("\n            表示偏高\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "max-min f-identify"
  }, [_c('div', {
    staticClass: "down-frame"
  }), _vm._v("\n            表示偏低\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-252a20c5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/myreport/LabDetail.vue
// module id = 800
// module chunks = 0